/**
 * @generated SignedSource<<312116b9ed902cb54853325e345005e2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductTaskResultStatus = "ERROR" | "PARTIAL" | "PENDING" | "SKIPPED" | "SUCCESS";
export type ProductTaskState = "CANCELLED" | "COMPLETED" | "ERROR" | "PARTIAL_SUCCESS" | "PROCESSING" | "WAITING";
export type productDuplicationTaskQueriesListQuery$variables = {
  status?: number | null;
  type?: string | null;
};
export type productDuplicationTaskQueriesListQuery$data = {
  readonly productTasks: ReadonlyArray<{
    readonly createdOn: string;
    readonly id: string;
    readonly isLocked: boolean;
    readonly modifiedOn: string;
    readonly progress: {
      readonly completedOperations: number;
      readonly overallProgress: number;
      readonly totalOperations: number;
    } | null;
    readonly result: {
      readonly completedAt: string | null;
      readonly failedProducts: number;
      readonly overallErrorMessage: string | null;
      readonly overallStatus: ProductTaskResultStatus;
      readonly successfulProducts: number;
      readonly totalProducts: number;
    } | null;
    readonly settings: {
      readonly assignPricingRules: boolean;
      readonly cloneTemplates: boolean | null;
      readonly destinationProductIds: ReadonlyArray<string>;
      readonly salesChannelId: number | null;
      readonly sellerID: number;
      readonly sourceProductId: string;
      readonly userID: number | null;
    } | null;
    readonly status: number;
    readonly taskID: number;
    readonly taskState: ProductTaskState;
    readonly type: string;
  }>;
};
export type productDuplicationTaskQueriesListQuery = {
  response: productDuplicationTaskQueriesListQuery$data;
  variables: productDuplicationTaskQueriesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "ProductTaskDto",
    "kind": "LinkedField",
    "name": "productTasks",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLocked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskSettingsDto",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationProductIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloneTemplates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignPricingRules",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskProgressDto",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskResultDto",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallErrorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "successfulProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failedProducts",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesListQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesListQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c453ae61aa6051175103dad06d898b41",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesListQuery",
    "operationKind": "query",
    "text": "query productDuplicationTaskQueriesListQuery(\n  $status: Int\n  $type: String\n) {\n  productTasks(status: $status, type: $type) {\n    id\n    taskID\n    type\n    status\n    taskState\n    isLocked\n    createdOn\n    modifiedOn\n    settings {\n      sourceProductId\n      destinationProductIds\n      cloneTemplates\n      assignPricingRules\n      salesChannelId\n      sellerID\n      userID\n    }\n    progress {\n      totalOperations\n      completedOperations\n      overallProgress\n    }\n    result {\n      overallStatus\n      overallErrorMessage\n      completedAt\n      totalProducts\n      successfulProducts\n      failedProducts\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2d786233fcde0ab9db95941e21128b6";

export default node;
